export enum VariableSchemaType {
  ENVIRONMENT_VARIABLE = 'ENVIRONMENT_VARIABLE',
  DEPLOYMENT_VARIABLE = 'DEPLOYMENT_VARIABLE',
  RUN_VARIABLE = 'RUN_VARIABLE',
}
